const paymentSelector = {
  paymentData: state => state.paymentReducer.paymentData,
  isPaymentDataLoaded: state => state.paymentReducer.isPaymentDataLoaded
}

export default paymentSelector
